/*
 * @Author: your name
 * @Date: 2021-11-16 09:44:19
 * @LastEditTime: 2021-11-17 15:36:37
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \team-web\src\api\apiWorker.js
 */
import request from '@/http'
const url = process.env.VUE_APP_APIMACHINERY
const url2 = process.env.VUE_APP_APIUSER
// const urls = 'http://192.168.2.42:9999'
export const apiWorker = {
  // 获取出租筛选地址
  getAccessToAreas: async (page, limit) => {
    return new Promise(async (resolve, reject) => {
      request.get(url + `/api/sysMachineryBasicArea/getSimpleAreaList`)
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取工种
  getWorkType: async () => {
    return new Promise(async (resolve, reject) => {
      request.get(`/occupationConfig/list`)
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  teamInfoSearchList: (data) => request.post(`/worker/list`, data), // 找工人列表
  ForemanSearchList: (data) => request.post(`/classLeader/list/page`, data), // 班组长列表
  getWorkerDetail: (no, type) => request.get(`/worker/detailWorker?no=${no}&type=${type}`), // 工人详情
  getForemanDetail: (no) => request.get(`/classLeader/detail/${no}`), // 班组长详情
  getSelect: () => request.get(`/classLeader/getSelect`), // 获取找工人分类数据
  getListChild: () => request.get(`/occupationConfig/listChild`), // 获取找工人分类 类别 工种 三级联动数据
  updatePhoneCount: (no) => request.get(`/worker/update/count/${no}`), // 更新工人电话联系次数
  getAllRecommendInfo: (industryNo, categoryNo) => request.get(`/worker/getAllRecommendInfo?industryNo=${industryNo}&categoryNo=${categoryNo}`) ,// 推荐数据
  getfindUserByNo: (userNo) => request.get(`${url2}/api/user/findUserByNo?userNo=${userNo}`), // 根据用户编号获取用户信息
  getLobarDefault:()=>request.get(`/occupationConfig/findMore`), // 获取首页banner左侧劳务行业列表缺省类目
}
